import React from "react";
import contactImage from "../../../asset/contact.png";

export const ContactInfo = () => {
  const backgroundImageStyle = {
    backgroundImage: `url('${contactImage}')`, // Replace with the actual path to your image
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };

  return (
    <div
      className="text-center p-6 shadow-md mt-8"
      style={backgroundImageStyle}
    >
      <div className="p-6 rounded-lg">
        <h2 className="text-2xl font-bold mb-4 text-white">
          الجودة العالية والسعر المناسب في موقع سنا بيسز
        </h2>
        <p className="text-lg mb-4 text-white">
          الاستفسار على الأرقام المذكورة
        </p>
        <div className="flex justify-center gap-4 mb-4">
          <a href="tel:07709990958" className="text-lg text-white">
            0770 999 0958
          </a>
          <a href="tel:07709990958" className="text-lg text-white">
            0770 999 0958
          </a>
        </div>
      </div>
    </div>
  );
};
